// src/i18n/profit.ts —— C-32 利润台账页文案包（经 PageDef.i18n 挂入 table 域字典，TD-849）。键一律 pf 前缀（J 组页包键前缀约定）。
// 页名 / 页头副题 / 权限矩阵模块名（profit / hProfit）属外壳包（i18n/shell.ts），本包只引用；原型键（aDetail aClose cTime cType）只引用不定义
import type { I18nPack } from '../../../shared/src/dc';

export const I18N_PROFIT: I18nPack = {
  zh: {
    // ---- 页签 ----
    pfTabType: '按类型',
    pfTabAgent: '按代理',
    pfTabDay: '按日',
    pfTabProduct: '按产品',
    pfTabEntries: '明细',
    // ---- 统计卡 ----
    pfKGross: '用户实付',
    pfKAgent: '代理所得',
    pfKInvite: '邀请奖励',
    pfKCost: '已知成本',
    pfKNet: '平台净利润',
    pfKManual: '调账净额（未计入）',
    pfKPayable: '应付代理（未付）',
    pfSubCount: '{n} 笔 · 其中欠费 ${owed}',
    pfSubPlatform: '平台份额 ${v}',
    pfSubInvite: '用户邀请两级奖励',
    pfSubCost: '开卡 / 销卡成本 + 上游补款成本（充值 × 平台补款成本率）+ 重组差额',
    pfSubBuild: '构建至 {t} · 对账 {d} {s}',
    pfSubBuildNone: '尚无构建记录',
    pfSubManual: '调增 ${credit} · 调减 ${debit}（{n} 笔）',
    pfSubPayable: '代收 ${collected} · 已付 ${paid}',
    pfReconNone: '—',
    pfNote: '已知成本 = 开卡 / 销卡成本 + 上游补款成本（充值 × 平台补款成本率，按充值时点费率）+ 重组差额；未含上游交易成本（跨境、退款、预算充值等）与链上矿工 / 能量 / 激活成本；不含旧版（无支付事件）充值链路的重组损失；欠费按应收计；调账单独列示不计入',
    // ---- 列 ----
    pfCGroupType: '类型',
    pfCAgent: '渠道代理',
    pfCDay: '日期',
    pfCProduct: '产品',
    pfCCount: '笔数',
    pfCGross: '用户实付',
    pfCAgentAmt: '代理所得',
    pfCSelf: '其中本代理',
    pfCInvite: '邀请奖励',
    pfCCost: '已知成本',
    pfCNet: '平台净利润',
    pfCOwed: '其中欠费',
    pfCSource: '来源单据',
    pfCUser: '用户',
    pfCSim: '模拟到账',
    pfDirect: '平台直属',
    pfNoProduct: '无产品',
    pfNotIn: '不计入净利润',
    pfSimYes: '含模拟到账',
    pfSimNo: '排除模拟到账',
    // ---- 收入类型 ----
    pfTypeCardOpen: '开卡费',
    pfTypeCardWithdraw: '卡转出费',
    pfTypeCardClose: '销卡费',
    pfTypeCardTxFee: '卡交易费',
    pfTypeDepositFee: '充值手续费',
    pfTypeDepositFxPlatform: '平台汇率差',
    pfTypeDepositFxAgent: '代理汇率差',
    pfTypeWithdrawFee: '提币手续费',
    pfTypeWithdrawActivation: '激活服务费',
    pfTypeAgentWdFee: '提佣手续费',
    pfTypeReorgLoss: '重组损失',
    pfTypeManualAdjust: '后台调账（不计入）',
    // ---- 来源 ----
    pfSrcCardAction: '卡操作单',
    pfSrcCardTx: '卡交易',
    pfSrcDeposit: '充值单',
    pfSrcWithdrawal: '提币单',
    pfSrcAgentWd: '代理提佣单',
    pfSrcReorg: '重组冻结',
    pfSrcLedger: '钱包流水',
    // ---- 成本口径 ----
    pfCostNone: '无',
    pfCostLive: '产品当前值',
    pfCostOplog: '按改价日志回溯',
    pfCostReorg: '重组未冻结差额',
    pfCostSettings: '充值 × 平台补款成本率',
    // ---- 抽屉 ----
    pfDrawerKind: '利润台账',
    pfFSourceType: '来源类型',
    pfFSourceNo: '来源单号',
    pfFSourceId: '来源 id',
    pfFOccurred: '确认时间',
    pfFPlatform: '平台份额',
    pfFCostBasis: '成本口径',
    pfFInNet: '计入净利润',
    pfFBuilt: '入账时间',
    pfFRebuilt: '重述',
    pfRebuiltSub: '{t} · 第 {n} 次',
    pfNever: '未重述',
    pfYes: '是',
    pfNo: '否',
    pfOpenSource: '查看来源',
    pfOpenUser: '用户 360',
  },
  en: {
    pfTabType: 'By type',
    pfTabAgent: 'By agent',
    pfTabDay: 'By day',
    pfTabProduct: 'By product',
    pfTabEntries: 'Entries',
    pfKGross: 'Paid by users',
    pfKAgent: 'Agent share',
    pfKInvite: 'Invite rewards',
    pfKCost: 'Known cost',
    pfKNet: 'Net platform profit',
    pfKManual: 'Manual adjustments (excluded)',
    pfKPayable: 'Payable to agents (unpaid)',
    pfSubCount: '{n} entries · owed ${owed}',
    pfSubPlatform: 'Platform share ${v}',
    pfSubInvite: 'Two-level user invite rewards',
    pfSubCost: 'Card open / close cost + upstream top-up cost (deposit × platform top-up cost rate) + reorg shortfall',
    pfSubBuild: 'Built to {t} · recon {d} {s}',
    pfSubBuildNone: 'Not built yet',
    pfSubManual: 'Credited ${credit} · debited ${debit} ({n})',
    pfSubPayable: 'Collected ${collected} · paid ${paid}',
    pfReconNone: '—',
    pfNote: 'Known cost = card open / close cost + upstream top-up cost (deposit × platform top-up cost rate at the deposit time) + reorg shortfall; excludes upstream transaction costs (cross-border, refunds, budget top-ups, etc.) and on-chain gas / energy / activation costs; excludes reorg losses on the legacy deposit path (no payment event); owed fees are counted as receivable; manual adjustments are listed separately and excluded',
    pfCGroupType: 'Type',
    pfCAgent: 'Channel agent',
    pfCDay: 'Date',
    pfCProduct: 'Product',
    pfCCount: 'Entries',
    pfCGross: 'Paid by users',
    pfCAgentAmt: 'Agent share',
    pfCSelf: 'Own share',
    pfCInvite: 'Invite rewards',
    pfCCost: 'Known cost',
    pfCNet: 'Net profit',
    pfCOwed: 'Owed part',
    pfCSource: 'Source',
    pfCUser: 'User',
    pfCSim: 'Simulated',
    pfDirect: 'Platform direct',
    pfNoProduct: 'No product',
    pfNotIn: 'Excluded from net profit',
    pfSimYes: 'Include simulated',
    pfSimNo: 'Exclude simulated',
    pfTypeCardOpen: 'Card opening fee',
    pfTypeCardWithdraw: 'Card withdrawal fee',
    pfTypeCardClose: 'Card closing fee',
    pfTypeCardTxFee: 'Card transaction fee',
    pfTypeDepositFee: 'Top-up fee',
    pfTypeDepositFxPlatform: 'Platform FX spread',
    pfTypeDepositFxAgent: 'Agent FX spread',
    pfTypeWithdrawFee: 'Withdrawal fee',
    pfTypeWithdrawActivation: 'Activation service fee',
    pfTypeAgentWdFee: 'Commission withdrawal fee',
    pfTypeReorgLoss: 'Reorg loss',
    pfTypeManualAdjust: 'Manual adjustment (excluded)',
    pfSrcCardAction: 'Card operation',
    pfSrcCardTx: 'Card transaction',
    pfSrcDeposit: 'Deposit',
    pfSrcWithdrawal: 'Withdrawal',
    pfSrcAgentWd: 'Agent withdrawal',
    pfSrcReorg: 'Reorg hold',
    pfSrcLedger: 'Wallet ledger',
    pfCostNone: 'None',
    pfCostLive: 'Current product value',
    pfCostOplog: 'From price-change log',
    pfCostReorg: 'Reorg unfrozen shortfall',
    pfCostSettings: 'Deposit × platform top-up cost rate',
    pfDrawerKind: 'Profit ledger',
    pfFSourceType: 'Source type',
    pfFSourceNo: 'Source no.',
    pfFSourceId: 'Source id',
    pfFOccurred: 'Recognized at',
    pfFPlatform: 'Platform share',
    pfFCostBasis: 'Cost basis',
    pfFInNet: 'In net profit',
    pfFBuilt: 'Booked at',
    pfFRebuilt: 'Restated',
    pfRebuiltSub: '{t} · #{n}',
    pfNever: 'Never',
    pfYes: 'Yes',
    pfNo: 'No',
    pfOpenSource: 'Open source',
    pfOpenUser: 'User 360',
  },
};

// 原型无此页，本包不覆盖任何原型键
export const REWRITES_PROFIT: readonly string[] = [];
